import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  CloseButton,
  Flex,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'src/components/atoms/Button';
import { useMfaPreferenceQuery } from 'src/hooks/useMfaPreference';

const DISMISSED_STORAGE_KEY = 'merkatus.mfaNudgeDismissed';

/**
 * Dismissible banner nudging signed-in users without an authenticator
 * app towards setting one up in Settings. Email MFA is always on.
 */
export const MfaNudgeBanner: React.FC = () => {
  const { data: mfaPreference } = useMfaPreferenceQuery();
  const navigate = useNavigate();
  const [isDismissed, setIsDismissed] = useState(
    () => localStorage.getItem(DISMISSED_STORAGE_KEY) === '1',
  );

  const isTotpEnabled = Boolean(mfaPreference?.enabled?.includes('TOTP'));

  if (!mfaPreference || isTotpEnabled || isDismissed) {
    return null;
  }

  const handleDismiss = () => {
    localStorage.setItem(DISMISSED_STORAGE_KEY, '1');
    setIsDismissed(true);
  };

  const handleGoToSettings = () => {
    navigate('/settings');
  };

  return (
    <Alert status="info" variant="left-accent">
      <AlertIcon />
      <Flex
        flex="1"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        gap={2}>
        <Box>
          <AlertTitle>Protect your account</AlertTitle>
          <AlertDescription>
            Set up an authenticator app for faster, more secure sign-in.
          </AlertDescription>
        </Box>
        <Button
          buttonName="mfa-nudge-go-to-settings"
          size="sm"
          variant="outline"
          onClick={handleGoToSettings}>
          Set up now
        </Button>
      </Flex>
      <CloseButton
        alignSelf="flex-start"
        position="relative"
        right={-1}
        top={-1}
        onClick={handleDismiss}
      />
    </Alert>
  );
};
